import { render, staticRenderFns } from "./companyCard.vue?vue&type=template&id=4c6ffec0&scoped=true"
import script from "./companyCard.vue?vue&type=script&lang=js"
export * from "./companyCard.vue?vue&type=script&lang=js"
import style0 from "./companyCard.vue?vue&type=style&index=0&id=4c6ffec0&lang=scss&scoped=true"
import style1 from "./companyCard.vue?vue&type=style&index=1&id=4c6ffec0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ffec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6ffec0')) {
      api.createRecord('4c6ffec0', component.options)
    } else {
      api.reload('4c6ffec0', component.options)
    }
    module.hot.accept("./companyCard.vue?vue&type=template&id=4c6ffec0&scoped=true", function () {
      api.rerender('4c6ffec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/companyCard.vue"
export default component.exports